

export default function GlobusSvg(props) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
            <g clipPath="url(#clip0_8431_701)">
                <path d="M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8.00001C14.6666 4.31811 11.6818 1.33334 7.99992 1.33334C4.31802 1.33334 1.33325 4.31811 1.33325 8.00001C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z" stroke="#282828"/>
                <path d="M7.99992 14.6667C9.47268 14.6667 10.6666 11.6819 10.6666 8.00001C10.6666 4.31811 9.47268 1.33334 7.99992 1.33334C6.52716 1.33334 5.33325 4.31811 5.33325 8.00001C5.33325 11.6819 6.52716 14.6667 7.99992 14.6667Z" stroke="#282828"/>
                <path d="M1.33325 8H14.6666" stroke="#282828" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_8431_701">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}